@file:Suppress("unused", "UNUSED_CHANGED_VALUE", "PropertyName", "FunctionName", "ClassName", "RedundantVisibilityModifier")

package com.steamstreet.vegasful.graphql.api.client

import com.steamstreet.graphkt.GraphKtQuery
import com.steamstreet.graphkt.ID
import com.steamstreet.graphkt.client.GraphQLClient
import com.steamstreet.graphkt.client.QueryWriter
import com.steamstreet.vegasful.graphql.api.AWSDateTime
import com.steamstreet.vegasful.graphql.api.ArticleInput
import com.steamstreet.vegasful.graphql.api.ArticleSearchInput
import com.steamstreet.vegasful.graphql.api.ClearUserDataInput
import com.steamstreet.vegasful.graphql.api.ContentPanelInput
import com.steamstreet.vegasful.graphql.api.ConversationInput
import com.steamstreet.vegasful.graphql.api.CreateAnonymousInput
import com.steamstreet.vegasful.graphql.api.DeviceTokenRegistration
import com.steamstreet.vegasful.graphql.api.EventSearch
import com.steamstreet.vegasful.graphql.api.EventUpdateInput
import com.steamstreet.vegasful.graphql.api.GlobalSearchInput
import com.steamstreet.vegasful.graphql.api.ImageUpload
import com.steamstreet.vegasful.graphql.api.InteractInput
import com.steamstreet.vegasful.graphql.api.InteractionType
import com.steamstreet.vegasful.graphql.api.LikeInput
import com.steamstreet.vegasful.graphql.api.LoaderConfiguration
import com.steamstreet.vegasful.graphql.api.LoaderExecutionInput
import com.steamstreet.vegasful.graphql.api.LoaderPublishInput
import com.steamstreet.vegasful.graphql.api.LogQueryInput
import com.steamstreet.vegasful.graphql.api.MergeInput
import com.steamstreet.vegasful.graphql.api.PerformerSearch
import com.steamstreet.vegasful.graphql.api.PerformerUpdateInput
import com.steamstreet.vegasful.graphql.api.ShareInput
import com.steamstreet.vegasful.graphql.api.SocialImageDateStyle
import com.steamstreet.vegasful.graphql.api.SocialImageRenderer
import com.steamstreet.vegasful.graphql.api.SubscriptionInput
import com.steamstreet.vegasful.graphql.api.SystemEventInput
import com.steamstreet.vegasful.graphql.api.TagUpdateInput
import com.steamstreet.vegasful.graphql.api.VariantInput
import com.steamstreet.vegasful.graphql.api.VenueUpdateInput
import com.steamstreet.vegasful.graphql.api.ViewQuery
import com.steamstreet.vegasful.graphql.api.json
import kotlin.Boolean
import kotlin.Int
import kotlin.String
import kotlin.Suppress
import kotlin.Unit
import kotlin.collections.List
import kotlinx.serialization.builtins.serializer

@GraphKtQuery
public class _QueryQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val permissions: Unit
    get() {
      writer.println("permissions")
    }

  public fun venues(block: _VenuesQuery.() -> Unit) {
    writer.print("venues")
    writer.println(" {")
    writer.indent {
      _VenuesQuery(it).block()
    }
    writer.println("}")
  }

  public fun events(block: _EventsQuery.() -> Unit) {
    writer.print("events")
    writer.println(" {")
    writer.indent {
      _EventsQuery(it).block()
    }
    writer.println("}")
  }

  public fun performers(block: _PerformersQuery.() -> Unit) {
    writer.print("performers")
    writer.println(" {")
    writer.indent {
      _PerformersQuery(it).block()
    }
    writer.println("}")
  }

  public fun tags(block: _TagsQuery.() -> Unit) {
    writer.print("tags")
    writer.println(" {")
    writer.indent {
      _TagsQuery(it).block()
    }
    writer.println("}")
  }

  public fun articles(block: _ArticlesQuery.() -> Unit) {
    writer.print("articles")
    writer.println(" {")
    writer.indent {
      _ArticlesQuery(it).block()
    }
    writer.println("}")
  }

  public fun content(block: _ContentQuery.() -> Unit) {
    writer.print("content")
    writer.println(" {")
    writer.indent {
      _ContentQuery(it).block()
    }
    writer.println("}")
  }

  public fun search(input: GlobalSearchInput, block: _GlobalSearchResultsQuery.() -> Unit) {
    writer.print("search")
    writer.print("(")
    writer.print("input: \$${writer.variable("input", "GlobalSearchInput!", GlobalSearchInput.serializer(), input)}")
    writer.print(")")
    writer.println(" {")
    writer.indent {
      _GlobalSearchResultsQuery(it).block()
    }
    writer.println("}")
  }

  public fun typeahead(input: GlobalSearchInput, block: _GlobalSearchResultsQuery.() -> Unit) {
    writer.print("typeahead")
    writer.print("(")
    writer.print("input: \$${writer.variable("input", "GlobalSearchInput!", GlobalSearchInput.serializer(), input)}")
    writer.print(")")
    writer.println(" {")
    writer.indent {
      _GlobalSearchResultsQuery(it).block()
    }
    writer.println("}")
  }

  public fun conversations(block: _ConversationsQuery.() -> Unit) {
    writer.print("conversations")
    writer.println(" {")
    writer.indent {
      _ConversationsQuery(it).block()
    }
    writer.println("}")
  }

  public fun subscriptions(block: _SubscriptionsQuery.() -> Unit) {
    writer.print("subscriptions")
    writer.println(" {")
    writer.indent {
      _SubscriptionsQuery(it).block()
    }
    writer.println("}")
  }

  public fun entity(path: String, block: _EntityQuery.() -> Unit) {
    writer.print("entity")
    writer.print("(")
    writer.print("path: \$${writer.variable("path", "String!", path)}")
    writer.print(")")
    writer.println(" {")
    writer.indent {
      _EntityQuery(it).block()
    }
    writer.println("}")
  }

  public fun entities(path: List<String>, block: _EntityQuery.() -> Unit) {
    writer.print("entities")
    writer.print("(")
    writer.print("path: \$${writer.variable("path", "null!", path)}")
    writer.print(")")
    writer.println(" {")
    writer.indent {
      _EntityQuery(it).block()
    }
    writer.println("}")
  }

  public fun contentViews(block: _ContentViewsQuery.() -> Unit) {
    writer.print("contentViews")
    writer.println(" {")
    writer.indent {
      _ContentViewsQuery(it).block()
    }
    writer.println("}")
  }

  public fun clientSupport(block: _ClientSupportQuery.() -> Unit) {
    writer.print("clientSupport")
    writer.println(" {")
    writer.indent {
      _ClientSupportQuery(it).block()
    }
    writer.println("}")
  }

  public fun auxContent(block: _AuxContentQuery.() -> Unit) {
    writer.print("auxContent")
    writer.println(" {")
    writer.indent {
      _AuxContentQuery(it).block()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _ContentQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public fun venues(block: _VenuesQuery.() -> Unit) {
    writer.print("venues")
    writer.println(" {")
    writer.indent {
      _VenuesQuery(it).block()
    }
    writer.println("}")
  }

  public fun events(block: _EventsQuery.() -> Unit) {
    writer.print("events")
    writer.println(" {")
    writer.indent {
      _EventsQuery(it).block()
    }
    writer.println("}")
  }

  public fun performers(block: _PerformersQuery.() -> Unit) {
    writer.print("performers")
    writer.println(" {")
    writer.indent {
      _PerformersQuery(it).block()
    }
    writer.println("}")
  }

  public fun tags(block: _TagsQuery.() -> Unit) {
    writer.print("tags")
    writer.println(" {")
    writer.indent {
      _TagsQuery(it).block()
    }
    writer.println("}")
  }

  public fun entities(path: List<String>, block: _EntityQuery.() -> Unit) {
    writer.print("entities")
    writer.print("(")
    writer.print("path: \$${writer.variable("path", "null!", path)}")
    writer.print(")")
    writer.println(" {")
    writer.indent {
      _EntityQuery(it).block()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _MutationQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public fun admin(block: _AdminMutationQuery.() -> Unit) {
    writer.print("admin")
    writer.println(" {")
    writer.indent {
      _AdminMutationQuery(it).block()
    }
    writer.println("}")
  }

  public fun subscriptions(block: _SubscriptionsMutatorQuery.() -> Unit) {
    writer.print("subscriptions")
    writer.println(" {")
    writer.indent {
      _SubscriptionsMutatorQuery(it).block()
    }
    writer.println("}")
  }

  public fun accounts(block: _AccountsQuery.() -> Unit) {
    writer.print("accounts")
    writer.println(" {")
    writer.indent {
      _AccountsQuery(it).block()
    }
    writer.println("}")
  }

  public fun clientSupport(block: _ClientSupportQuery.() -> Unit) {
    writer.print("clientSupport")
    writer.println(" {")
    writer.indent {
      _ClientSupportQuery(it).block()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _ConversationsQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public fun start(input: ConversationInput, block: _ConversationQuery.() -> Unit) {
    writer.print("start")
    writer.print("(")
    writer.print("input: \$${writer.variable("input", "ConversationInput!", ConversationInput.serializer(), input)}")
    writer.print(")")
    writer.println(" {")
    writer.indent {
      _ConversationQuery(it).block()
    }
    writer.println("}")
  }

  public fun conversation(id: ID, block: _ConversationQuery.() -> Unit) {
    writer.print("conversation")
    writer.print("(")
    writer.print("id: \$${writer.variable("id", "ID!", id)}")
    writer.print(")")
    writer.println(" {")
    writer.indent {
      _ConversationQuery(it).block()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _ConversationQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val id: Unit
    get() {
      writer.println("id")
    }

  public val status: Unit
    get() {
      writer.println("status")
    }

  public val response: Unit
    get() {
      writer.println("response")
    }

  public fun panels(block: _ContentPanelQuery.() -> Unit) {
    writer.print("panels")
    writer.println(" {")
    writer.indent {
      _ContentPanelQuery(it).block()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _GlobalSearchResultsQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public fun events(block: _EventQuery.() -> Unit) {
    writer.print("events")
    writer.println(" {")
    writer.indent {
      _EventQuery(it).block()
    }
    writer.println("}")
  }

  public fun venues(block: _VenueQuery.() -> Unit) {
    writer.print("venues")
    writer.println(" {")
    writer.indent {
      _VenueQuery(it).block()
    }
    writer.println("}")
  }

  public fun tags(block: _TagQuery.() -> Unit) {
    writer.print("tags")
    writer.println(" {")
    writer.indent {
      _TagQuery(it).block()
    }
    writer.println("}")
  }

  public fun performers(block: _PerformerQuery.() -> Unit) {
    writer.print("performers")
    writer.println(" {")
    writer.indent {
      _PerformerQuery(it).block()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _EntityQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val id: Unit
    get() {
      writer.println("id")
    }

  public val name: Unit
    get() {
      writer.println("name")
    }

  public val description: Unit
    get() {
      writer.println("description")
    }

  public val path: Unit
    get() {
      writer.println("path")
    }

  public fun onVenue(block: _VenueQuery.() -> Unit) {
    writer.println("... on Venue {")
    writer.indent {
      _VenueQuery(writer).block()
    }
    writer.println("}")
  }

  public fun onTag(block: _TagQuery.() -> Unit) {
    writer.println("... on Tag {")
    writer.indent {
      _TagQuery(writer).block()
    }
    writer.println("}")
  }

  public fun onEvent(block: _EventQuery.() -> Unit) {
    writer.println("... on Event {")
    writer.indent {
      _EventQuery(writer).block()
    }
    writer.println("}")
  }

  public fun onPerformer(block: _PerformerQuery.() -> Unit) {
    writer.println("... on Performer {")
    writer.indent {
      _PerformerQuery(writer).block()
    }
    writer.println("}")
  }

  public fun onArticle(block: _ArticleQuery.() -> Unit) {
    writer.println("... on Article {")
    writer.indent {
      _ArticleQuery(writer).block()
    }
    writer.println("}")
  }

  public fun onContentViewEntity(block: _ContentViewEntityQuery.() -> Unit) {
    writer.println("... on ContentViewEntity {")
    writer.indent {
      _ContentViewEntityQuery(writer).block()
    }
    writer.println("}")
  }

  public fun images(block: _ImageQuery.() -> Unit) {
    writer.print("images")
    writer.println(" {")
    writer.indent {
      _ImageQuery(it).block()
    }
    writer.println("}")
  }

  public fun tags(block: _TagQuery.() -> Unit) {
    writer.print("tags")
    writer.println(" {")
    writer.indent {
      _TagQuery(it).block()
    }
    writer.println("}")
  }

  public fun events(input: EventSearch, block: _EventSearchResultsQuery.() -> Unit) {
    writer.print("events")
    writer.print("(")
    writer.print("input: \$${writer.variable("input", "EventSearch!", EventSearch.serializer(), input)}")
    writer.print(")")
    writer.println(" {")
    writer.indent {
      _EventSearchResultsQuery(it).block()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _VenuesQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public fun root(block: _VenueQuery.() -> Unit) {
    writer.print("root")
    writer.println(" {")
    writer.indent {
      _VenueQuery(it).block()
    }
    writer.println("}")
  }

  public fun venue(id: ID, block: _VenueQuery.() -> Unit) {
    writer.print("venue")
    writer.print("(")
    writer.print("id: \$${writer.variable("id", "ID!", id)}")
    writer.print(")")
    writer.println(" {")
    writer.indent {
      _VenueQuery(it).block()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _VenueQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val id: Unit
    get() {
      writer.println("id")
    }

  public val name: Unit
    get() {
      writer.println("name")
    }

  public val description: Unit
    get() {
      writer.println("description")
    }

  public val path: Unit
    get() {
      writer.println("path")
    }

  public val status: Unit
    get() {
      writer.println("status")
    }

  public val redirect: Unit
    get() {
      writer.println("redirect")
    }

  public val ticketsUrl: Unit
    get() {
      writer.println("ticketsUrl")
    }

  public val eventStreamId: Unit
    get() {
      writer.println("eventStreamId")
    }

  public val parking: Unit
    get() {
      writer.println("parking")
    }

  public fun parent(block: _VenueQuery.() -> Unit) {
    writer.print("parent")
    writer.println(" {")
    writer.indent {
      _VenueQuery(it).block()
    }
    writer.println("}")
  }

  public fun links(block: _SocialLinkQuery.() -> Unit) {
    writer.print("links")
    writer.println(" {")
    writer.indent {
      _SocialLinkQuery(it).block()
    }
    writer.println("}")
  }

  public fun images(block: _ImageQuery.() -> Unit) {
    writer.print("images")
    writer.println(" {")
    writer.indent {
      _ImageQuery(it).block()
    }
    writer.println("}")
  }

  public fun tags(block: _TagQuery.() -> Unit) {
    writer.print("tags")
    writer.println(" {")
    writer.indent {
      _TagQuery(it).block()
    }
    writer.println("}")
  }

  public fun children(block: _VenueQuery.() -> Unit) {
    writer.print("children")
    writer.println(" {")
    writer.indent {
      _VenueQuery(it).block()
    }
    writer.println("}")
  }

  public fun location(block: _GPSCoordinatesQuery.() -> Unit) {
    writer.print("location")
    writer.println(" {")
    writer.indent {
      _GPSCoordinatesQuery(it).block()
    }
    writer.println("}")
  }

  public fun address(block: _AddressQuery.() -> Unit) {
    writer.print("address")
    writer.println(" {")
    writer.indent {
      _AddressQuery(it).block()
    }
    writer.println("}")
  }

  public fun events(input: EventSearch, block: _EventSearchResultsQuery.() -> Unit) {
    writer.print("events")
    writer.print("(")
    writer.print("input: \$${writer.variable("input", "EventSearch!", EventSearch.serializer(), input)}")
    writer.print(")")
    writer.println(" {")
    writer.indent {
      _EventSearchResultsQuery(it).block()
    }
    writer.println("}")
  }

  public fun contentView(block: _ViewConfigurationQuery.() -> Unit) {
    writer.print("contentView")
    writer.println(" {")
    writer.indent {
      _ViewConfigurationQuery(it).block()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _SocialLinkQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val type: Unit
    get() {
      writer.println("type")
    }

  public val locator: Unit
    get() {
      writer.println("locator")
    }
}

@GraphKtQuery
public class _AddressQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val street: Unit
    get() {
      writer.println("street")
    }

  public val city: Unit
    get() {
      writer.println("city")
    }

  public val state: Unit
    get() {
      writer.println("state")
    }

  public val zip: Unit
    get() {
      writer.println("zip")
    }

  public val country: Unit
    get() {
      writer.println("country")
    }
}

@GraphKtQuery
public class _GPSCoordinatesQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val latitude: Unit
    get() {
      writer.println("latitude")
    }

  public val longitude: Unit
    get() {
      writer.println("longitude")
    }
}

@GraphKtQuery
public class _ImageQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val id: Unit
    get() {
      writer.println("id")
    }

  public val uri: Unit
    get() {
      writer.println("uri")
    }

  public val width: Unit
    get() {
      writer.println("width")
    }

  public val height: Unit
    get() {
      writer.println("height")
    }

  public val variant: Unit
    get() {
      writer.println("variant")
    }

  public fun withWidth(width: Int, block: _ImageQuery.() -> Unit) {
    writer.print("withWidth")
    writer.print("(")
    writer.print("width: \$${writer.variable("width", "Int!", width)}")
    writer.print(")")
    writer.println(" {")
    writer.indent {
      _ImageQuery(it).block()
    }
    writer.println("}")
  }

  public fun variants(input: VariantInput, block: _ImageQuery.() -> Unit) {
    writer.print("variants")
    writer.print("(")
    writer.print("input: \$${writer.variable("input", "VariantInput!", VariantInput.serializer(), input)}")
    writer.print(")")
    writer.println(" {")
    writer.indent {
      _ImageQuery(it).block()
    }
    writer.println("}")
  }

  public fun small(block: _ImageQuery.() -> Unit) {
    writer.print("small")
    writer.println(" {")
    writer.indent {
      _ImageQuery(it).block()
    }
    writer.println("}")
  }

  public fun medium(block: _ImageQuery.() -> Unit) {
    writer.print("medium")
    writer.println(" {")
    writer.indent {
      _ImageQuery(it).block()
    }
    writer.println("}")
  }

  public fun large(block: _ImageQuery.() -> Unit) {
    writer.print("large")
    writer.println(" {")
    writer.indent {
      _ImageQuery(it).block()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _TagsQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public fun tag(id: ID, block: _TagQuery.() -> Unit) {
    writer.print("tag")
    writer.print("(")
    writer.print("id: \$${writer.variable("id", "ID!", id)}")
    writer.print(")")
    writer.println(" {")
    writer.indent {
      _TagQuery(it).block()
    }
    writer.println("}")
  }

  public fun tags(ids: List<ID>, block: _TagQuery.() -> Unit) {
    writer.print("tags")
    writer.print("(")
    writer.print("ids: \$${writer.variable("ids", "null!", ids)}")
    writer.print(")")
    writer.println(" {")
    writer.indent {
      _TagQuery(it).block()
    }
    writer.println("}")
  }

  public fun root(block: _TagQuery.() -> Unit) {
    writer.print("root")
    writer.println(" {")
    writer.indent {
      _TagQuery(it).block()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _TagQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val id: Unit
    get() {
      writer.println("id")
    }

  public val path: Unit
    get() {
      writer.println("path")
    }

  public val name: Unit
    get() {
      writer.println("name")
    }

  public val description: Unit
    get() {
      writer.println("description")
    }

  public val pageTitle: Unit
    get() {
      writer.println("pageTitle")
    }

  public val shadow: Unit
    get() {
      writer.println("shadow")
    }

  public fun images(block: _ImageQuery.() -> Unit) {
    writer.print("images")
    writer.println(" {")
    writer.indent {
      _ImageQuery(it).block()
    }
    writer.println("}")
  }

  public fun events(input: EventSearch, block: _EventSearchResultsQuery.() -> Unit) {
    writer.print("events")
    writer.print("(")
    writer.print("input: \$${writer.variable("input", "EventSearch!", EventSearch.serializer(), input)}")
    writer.print(")")
    writer.println(" {")
    writer.indent {
      _EventSearchResultsQuery(it).block()
    }
    writer.println("}")
  }

  public fun tags(block: _TagQuery.() -> Unit) {
    writer.print("tags")
    writer.println(" {")
    writer.indent {
      _TagQuery(it).block()
    }
    writer.println("}")
  }

  public fun parent(block: _TagQuery.() -> Unit) {
    writer.print("parent")
    writer.println(" {")
    writer.indent {
      _TagQuery(it).block()
    }
    writer.println("}")
  }

  public fun contentView(block: _ViewConfigurationQuery.() -> Unit) {
    writer.print("contentView")
    writer.println(" {")
    writer.indent {
      _ViewConfigurationQuery(it).block()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _EventsQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public fun event(id: ID, block: _EventQuery.() -> Unit) {
    writer.print("event")
    writer.print("(")
    writer.print("id: \$${writer.variable("id", "ID!", id)}")
    writer.print(")")
    writer.println(" {")
    writer.indent {
      _EventQuery(it).block()
    }
    writer.println("}")
  }

  public fun search(input: EventSearch, block: _EventSearchResultsQuery.() -> Unit) {
    writer.print("search")
    writer.print("(")
    writer.print("input: \$${writer.variable("input", "EventSearch!", EventSearch.serializer(), input)}")
    writer.print(")")
    writer.println(" {")
    writer.indent {
      _EventSearchResultsQuery(it).block()
    }
    writer.println("}")
  }

  public fun recentlyActive(input: EventSearch, block: _EventSearchResultsQuery.() -> Unit) {
    writer.print("recentlyActive")
    writer.print("(")
    writer.print("input: \$${writer.variable("input", "EventSearch!", EventSearch.serializer(), input)}")
    writer.print(")")
    writer.println(" {")
    writer.indent {
      _EventSearchResultsQuery(it).block()
    }
    writer.println("}")
  }

  public fun recentlyActiveByStream(
    stream: String,
    input: EventSearch,
    block: _EventSearchResultsQuery.() -> Unit,
  ) {
    writer.print("recentlyActiveByStream")
    writer.print("(")
    var count = 0
    if (count++ > 0) writer.print(", ")
    writer.print("stream: \$${writer.variable("stream", "String!", stream)}")
    if (count++ > 0) writer.print(", ")
    writer.print("input: \$${writer.variable("input", "EventSearch!", EventSearch.serializer(), input)}")
    writer.print(")")
    writer.println(" {")
    writer.indent {
      _EventSearchResultsQuery(it).block()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _EventQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val id: Unit
    get() {
      writer.println("id")
    }

  public val path: Unit
    get() {
      writer.println("path")
    }

  public val name: Unit
    get() {
      writer.println("name")
    }

  public val description: Unit
    get() {
      writer.println("description")
    }

  public val date: Unit
    get() {
      writer.println("date")
    }

  public val time: Unit
    get() {
      writer.println("time")
    }

  public val ts: Unit
    get() {
      writer.println("ts")
    }

  public val endDate: Unit
    get() {
      writer.println("endDate")
    }

  public val endTime: Unit
    get() {
      writer.println("endTime")
    }

  public val duration: Unit
    get() {
      writer.println("duration")
    }

  public val ticketsUrl: Unit
    get() {
      writer.println("ticketsUrl")
    }

  public val disabled: Unit
    get() {
      writer.println("disabled")
    }

  public val sourceUrl: Unit
    get() {
      writer.println("sourceUrl")
    }

  public val active: Unit
    get() {
      writer.println("active")
    }

  public val tagline: Unit
    get() {
      writer.println("tagline")
    }

  public val score: Unit
    get() {
      writer.println("score")
    }

  public val parking: Unit
    get() {
      writer.println("parking")
    }

  public fun venue(block: _VenueQuery.() -> Unit) {
    writer.print("venue")
    writer.println(" {")
    writer.indent {
      _VenueQuery(it).block()
    }
    writer.println("}")
  }

  public fun images(block: _ImageQuery.() -> Unit) {
    writer.print("images")
    writer.println(" {")
    writer.indent {
      _ImageQuery(it).block()
    }
    writer.println("}")
  }

  public fun tags(block: _TagQuery.() -> Unit) {
    writer.print("tags")
    writer.println(" {")
    writer.indent {
      _TagQuery(it).block()
    }
    writer.println("}")
  }

  public fun performers(block: _PerformerQuery.() -> Unit) {
    writer.print("performers")
    writer.println(" {")
    writer.indent {
      _PerformerQuery(it).block()
    }
    writer.println("}")
  }

  public fun parent(block: _EventQuery.() -> Unit) {
    writer.print("parent")
    writer.println(" {")
    writer.indent {
      _EventQuery(it).block()
    }
    writer.println("}")
  }

  public fun children(block: _EventQuery.() -> Unit) {
    writer.print("children")
    writer.println(" {")
    writer.indent {
      _EventQuery(it).block()
    }
    writer.println("}")
  }

  public fun events(input: EventSearch, block: _EventSearchResultsQuery.() -> Unit) {
    writer.print("events")
    writer.print("(")
    writer.print("input: \$${writer.variable("input", "EventSearch!", EventSearch.serializer(), input)}")
    writer.print(")")
    writer.println(" {")
    writer.indent {
      _EventSearchResultsQuery(it).block()
    }
    writer.println("}")
  }

  public fun related(input: EventSearch, block: _EventSearchResultsQuery.() -> Unit) {
    writer.print("related")
    writer.print("(")
    writer.print("input: \$${writer.variable("input", "EventSearch!", EventSearch.serializer(), input)}")
    writer.print(")")
    writer.println(" {")
    writer.indent {
      _EventSearchResultsQuery(it).block()
    }
    writer.println("}")
  }

  public fun contentView(block: _ViewConfigurationQuery.() -> Unit) {
    writer.print("contentView")
    writer.println(" {")
    writer.indent {
      _ViewConfigurationQuery(it).block()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _PerformersQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public fun performer(id: ID, block: _PerformerQuery.() -> Unit) {
    writer.print("performer")
    writer.print("(")
    writer.print("id: \$${writer.variable("id", "ID!", id)}")
    writer.print(")")
    writer.println(" {")
    writer.indent {
      _PerformerQuery(it).block()
    }
    writer.println("}")
  }

  public fun search(input: PerformerSearch, block: _PerformerResultsQuery.() -> Unit) {
    writer.print("search")
    writer.print("(")
    writer.print("input: \$${writer.variable("input", "PerformerSearch!", PerformerSearch.serializer(), input)}")
    writer.print(")")
    writer.println(" {")
    writer.indent {
      _PerformerResultsQuery(it).block()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _PerformerResultsQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val nextToken: Unit
    get() {
      writer.println("nextToken")
    }

  public fun performers(block: _PerformerQuery.() -> Unit) {
    writer.print("performers")
    writer.println(" {")
    writer.indent {
      _PerformerQuery(it).block()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _PerformerQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val id: Unit
    get() {
      writer.println("id")
    }

  public val path: Unit
    get() {
      writer.println("path")
    }

  public val name: Unit
    get() {
      writer.println("name")
    }

  public val description: Unit
    get() {
      writer.println("description")
    }

  public fun tags(block: _TagQuery.() -> Unit) {
    writer.print("tags")
    writer.println(" {")
    writer.indent {
      _TagQuery(it).block()
    }
    writer.println("}")
  }

  public fun events(input: EventSearch, block: _EventSearchResultsQuery.() -> Unit) {
    writer.print("events")
    writer.print("(")
    writer.print("input: \$${writer.variable("input", "EventSearch!", EventSearch.serializer(), input)}")
    writer.print(")")
    writer.println(" {")
    writer.indent {
      _EventSearchResultsQuery(it).block()
    }
    writer.println("}")
  }

  public fun images(block: _ImageQuery.() -> Unit) {
    writer.print("images")
    writer.println(" {")
    writer.indent {
      _ImageQuery(it).block()
    }
    writer.println("}")
  }

  public fun links(block: _SocialLinkQuery.() -> Unit) {
    writer.print("links")
    writer.println(" {")
    writer.indent {
      _SocialLinkQuery(it).block()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _ArticleSearchResultQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public fun articles(block: _ArticleQuery.() -> Unit) {
    writer.print("articles")
    writer.println(" {")
    writer.indent {
      _ArticleQuery(it).block()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _ArticlesQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public fun article(id: ID, block: _ArticleQuery.() -> Unit) {
    writer.print("article")
    writer.print("(")
    writer.print("id: \$${writer.variable("id", "ID!", id)}")
    writer.print(")")
    writer.println(" {")
    writer.indent {
      _ArticleQuery(it).block()
    }
    writer.println("}")
  }

  public fun recent(input: ArticleSearchInput, block: _ArticleSearchResultQuery.() -> Unit) {
    writer.print("recent")
    writer.print("(")
    writer.print("input: \$${writer.variable("input", "ArticleSearchInput!", ArticleSearchInput.serializer(), input)}")
    writer.print(")")
    writer.println(" {")
    writer.indent {
      _ArticleSearchResultQuery(it).block()
    }
    writer.println("}")
  }

  public fun query(input: ArticleSearchInput, block: _ArticleSearchResultQuery.() -> Unit) {
    writer.print("query")
    writer.print("(")
    writer.print("input: \$${writer.variable("input", "ArticleSearchInput!", ArticleSearchInput.serializer(), input)}")
    writer.print(")")
    writer.println(" {")
    writer.indent {
      _ArticleSearchResultQuery(it).block()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _ArticleQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val id: Unit
    get() {
      writer.println("id")
    }

  public val path: Unit
    get() {
      writer.println("path")
    }

  public val title: Unit
    get() {
      writer.println("title")
    }

  public val summary: Unit
    get() {
      writer.println("summary")
    }

  public val description: Unit
    get() {
      writer.println("description")
    }

  public val name: Unit
    get() {
      writer.println("name")
    }

  public val content: Unit
    get() {
      writer.println("content")
    }

  public val created: Unit
    get() {
      writer.println("created")
    }

  public val updated: Unit
    get() {
      writer.println("updated")
    }

  public val published: Unit
    get() {
      writer.println("published")
    }

  public fun tags(block: _TagQuery.() -> Unit) {
    writer.print("tags")
    writer.println(" {")
    writer.indent {
      _TagQuery(it).block()
    }
    writer.println("}")
  }

  public fun linkedEntities(block: _EntityQuery.() -> Unit) {
    writer.print("linkedEntities")
    writer.println(" {")
    writer.indent {
      _EntityQuery(it).block()
    }
    writer.println("}")
  }

  public fun images(block: _ImageQuery.() -> Unit) {
    writer.print("images")
    writer.println(" {")
    writer.indent {
      _ImageQuery(it).block()
    }
    writer.println("}")
  }

  public fun events(input: EventSearch, block: _EventSearchResultsQuery.() -> Unit) {
    writer.print("events")
    writer.print("(")
    writer.print("input: \$${writer.variable("input", "EventSearch!", EventSearch.serializer(), input)}")
    writer.print(")")
    writer.println(" {")
    writer.indent {
      _EventSearchResultsQuery(it).block()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _EventSearchResultsQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val pageToken: Unit
    get() {
      writer.println("pageToken")
    }

  public fun events(block: _EventQuery.() -> Unit) {
    writer.print("events")
    writer.println(" {")
    writer.indent {
      _EventQuery(it).block()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _SystemMutationQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public fun applicationEvent(input: SystemEventInput) {
    writer.print("applicationEvent")
    writer.print("(")
    writer.print("input: \$${writer.variable("input", "SystemEventInput!", SystemEventInput.serializer(), input)}")
    writer.print(")")
  }
}

@GraphKtQuery
public class _SubscriptionsQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public fun userSubscriptions(userId: String, block: _UserSubscriptionsQuery.() -> Unit) {
    writer.print("userSubscriptions")
    writer.print("(")
    writer.print("userId: \$${writer.variable("userId", "String!", userId)}")
    writer.print(")")
    writer.println(" {")
    writer.indent {
      _UserSubscriptionsQuery(it).block()
    }
    writer.println("}")
  }

  public fun mine(block: _UserSubscriptionsQuery.() -> Unit) {
    writer.print("mine")
    writer.println(" {")
    writer.indent {
      _UserSubscriptionsQuery(it).block()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _UserSubscriptionsQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public fun events(input: EventSearch, block: _EventSearchResultsQuery.() -> Unit) {
    writer.print("events")
    writer.print("(")
    writer.print("input: \$${writer.variable("input", "EventSearch!", EventSearch.serializer(), input)}")
    writer.print(")")
    writer.println(" {")
    writer.indent {
      _EventSearchResultsQuery(it).block()
    }
    writer.println("}")
  }

  public fun interactionsWithEntity(entityPath: String, block: _SubscriptionQuery.() -> Unit) {
    writer.print("interactionsWithEntity")
    writer.print("(")
    writer.print("entityPath: \$${writer.variable("entityPath", "String!", entityPath)}")
    writer.print(")")
    writer.println(" {")
    writer.indent {
      _SubscriptionQuery(it).block()
    }
    writer.println("}")
  }

  public fun interactionSummary(entityPath: String, block: _InteractionSummaryQuery.() -> Unit) {
    writer.print("interactionSummary")
    writer.print("(")
    writer.print("entityPath: \$${writer.variable("entityPath", "String!", entityPath)}")
    writer.print(")")
    writer.println(" {")
    writer.indent {
      _InteractionSummaryQuery(it).block()
    }
    writer.println("}")
  }

  public fun interactions(type: InteractionType, block: _SubscriptionQuery.() -> Unit) {
    writer.print("interactions")
    writer.print("(")
    writer.print("type: \$${writer.variable("type", "InteractionType!", type.name)}")
    writer.print(")")
    writer.println(" {")
    writer.indent {
      _SubscriptionQuery(it).block()
    }
    writer.println("}")
  }

  public fun recommendations(block: _UserRecommendationsQuery.() -> Unit) {
    writer.print("recommendations")
    writer.println(" {")
    writer.indent {
      _UserRecommendationsQuery(it).block()
    }
    writer.println("}")
  }

  public fun calendar(
    start: AWSDateTime?,
    end: AWSDateTime?,
    limit: Int?,
    paginationToken: String?,
    block: _EventSearchResultsQuery.() -> Unit,
  ) {
    writer.print("calendar")
    writer.print("(")
    var count = 0
    if (count++ > 0) writer.print(", ")
    if (start != null) {
      writer.print("start: \$${writer.variable("start", "AWSDateTime", AWSDateTime.serializer(), start)}")
    } else {
      writer.print("start: \$${writer.variable("start", "AWSDateTime", null)}")
    }
    if (count++ > 0) writer.print(", ")
    if (end != null) {
      writer.print("end: \$${writer.variable("end", "AWSDateTime", AWSDateTime.serializer(), end)}")
    } else {
      writer.print("end: \$${writer.variable("end", "AWSDateTime", null)}")
    }
    if (count++ > 0) writer.print(", ")
    if (limit != null) {
      writer.print("limit: \$${writer.variable("limit", "Int", limit)}")
    } else {
      writer.print("limit: \$${writer.variable("limit", "Int", null)}")
    }
    if (count++ > 0) writer.print(", ")
    if (paginationToken != null) {
      writer.print("paginationToken: \$${writer.variable("paginationToken", "String", paginationToken)}")
    } else {
      writer.print("paginationToken: \$${writer.variable("paginationToken", "String", null)}")
    }
    writer.print(")")
    writer.println(" {")
    writer.indent {
      _EventSearchResultsQuery(it).block()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _UserRecommendationsQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public fun entities(block: _UserRecommendationQuery.() -> Unit) {
    writer.print("entities")
    writer.println(" {")
    writer.indent {
      _UserRecommendationQuery(it).block()
    }
    writer.println("}")
  }

  public fun top(input: EventSearch, block: _EventSearchResultsQuery.() -> Unit) {
    writer.print("top")
    writer.print("(")
    writer.print("input: \$${writer.variable("input", "EventSearch!", EventSearch.serializer(), input)}")
    writer.print(")")
    writer.println(" {")
    writer.indent {
      _EventSearchResultsQuery(it).block()
    }
    writer.println("}")
  }

  public fun comingUp(block: _EventQuery.() -> Unit) {
    writer.print("comingUp")
    writer.println(" {")
    writer.indent {
      _EventQuery(it).block()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _UserRecommendationQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val score: Unit
    get() {
      writer.println("score")
    }

  public fun entity(block: _EntityQuery.() -> Unit) {
    writer.print("entity")
    writer.println(" {")
    writer.indent {
      _EntityQuery(it).block()
    }
    writer.println("}")
  }

  public fun events(block: _EventQuery.() -> Unit) {
    writer.print("events")
    writer.println(" {")
    writer.indent {
      _EventQuery(it).block()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _InteractionSummaryQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val path: Unit
    get() {
      writer.println("path")
    }

  public val liked: Unit
    get() {
      writer.println("liked")
    }
}

@GraphKtQuery
public class _SubscriptionQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val interactionType: Unit
    get() {
      writer.println("interactionType")
    }

  public val subscriber: Unit
    get() {
      writer.println("subscriber")
    }

  public val date: Unit
    get() {
      writer.println("date")
    }

  public val name: Unit
    get() {
      writer.println("name")
    }

  public val description: Unit
    get() {
      writer.println("description")
    }

  public fun target(block: _EntityQuery.() -> Unit) {
    writer.print("target")
    writer.println(" {")
    writer.indent {
      _EntityQuery(it).block()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _SubscriptionsMutatorQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public fun subscribe(input: SubscriptionInput, block: _SubscriptionQuery.() -> Unit) {
    writer.print("subscribe")
    writer.print("(")
    writer.print("input: \$${writer.variable("input", "SubscriptionInput!", SubscriptionInput.serializer(), input)}")
    writer.print(")")
    writer.println(" {")
    writer.indent {
      _SubscriptionQuery(it).block()
    }
    writer.println("}")
  }

  public fun unsubscribe(input: SubscriptionInput) {
    writer.print("unsubscribe")
    writer.print("(")
    writer.print("input: \$${writer.variable("input", "SubscriptionInput!", SubscriptionInput.serializer(), input)}")
    writer.print(")")
  }

  public fun clear(input: ClearUserDataInput) {
    writer.print("clear")
    writer.print("(")
    writer.print("input: \$${writer.variable("input", "ClearUserDataInput!", ClearUserDataInput.serializer(), input)}")
    writer.print(")")
  }

  public fun share(input: ShareInput) {
    writer.print("share")
    writer.print("(")
    writer.print("input: \$${writer.variable("input", "ShareInput!", ShareInput.serializer(), input)}")
    writer.print(")")
  }

  public fun like(input: LikeInput) {
    writer.print("like")
    writer.print("(")
    writer.print("input: \$${writer.variable("input", "LikeInput!", LikeInput.serializer(), input)}")
    writer.print(")")
  }

  public fun interact(input: InteractInput) {
    writer.print("interact")
    writer.print("(")
    writer.print("input: \$${writer.variable("input", "InteractInput!", InteractInput.serializer(), input)}")
    writer.print(")")
  }

  public fun clearInteraction(input: InteractInput) {
    writer.print("clearInteraction")
    writer.print("(")
    writer.print("input: \$${writer.variable("input", "InteractInput!", InteractInput.serializer(), input)}")
    writer.print(")")
  }

  public fun registerDevice(input: DeviceTokenRegistration) {
    writer.print("registerDevice")
    writer.print("(")
    writer.print("input: \$${writer.variable("input", "DeviceTokenRegistration!", DeviceTokenRegistration.serializer(), input)}")
    writer.print(")")
  }
}

@GraphKtQuery
public class _ContentViewsQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public fun view(id: String, block: _ContentViewQuery.() -> Unit) {
    writer.print("view")
    writer.print("(")
    writer.print("id: \$${writer.variable("id", "String!", id)}")
    writer.print(")")
    writer.println(" {")
    writer.indent {
      _ContentViewQuery(it).block()
    }
    writer.println("}")
  }

  public fun byId(
    id: ID,
    input: ViewQuery?,
    block: _ViewConfigurationQuery.() -> Unit,
  ) {
    writer.print("byId")
    writer.print("(")
    var count = 0
    if (count++ > 0) writer.print(", ")
    writer.print("id: \$${writer.variable("id", "ID!", id)}")
    if (count++ > 0) writer.print(", ")
    if (input != null) {
      writer.print("input: \$${writer.variable("input", "ViewQuery", ViewQuery.serializer(), input)}")
    } else {
      writer.print("input: \$${writer.variable("input", "ViewQuery", null)}")
    }
    writer.print(")")
    writer.println(" {")
    writer.indent {
      _ViewConfigurationQuery(it).block()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _ViewConfigurationQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val id: Unit
    get() {
      writer.println("id")
    }

  public fun panels(block: _ContentPanelQuery.() -> Unit) {
    writer.print("panels")
    writer.println(" {")
    writer.indent {
      _ContentPanelQuery(it).block()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _DateRangeQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val preset: Unit
    get() {
      writer.println("preset")
    }

  public val from: Unit
    get() {
      writer.println("from")
    }

  public val to: Unit
    get() {
      writer.println("to")
    }
}

@GraphKtQuery
public class _EventQueryQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val venues: Unit
    get() {
      writer.println("venues")
    }

  public val tags: Unit
    get() {
      writer.println("tags")
    }

  public val minScore: Unit
    get() {
      writer.println("minScore")
    }

  public val sort: Unit
    get() {
      writer.println("sort")
    }

  public val limit: Unit
    get() {
      writer.println("limit")
    }

  public fun dateRange(block: _DateRangeQuery.() -> Unit) {
    writer.print("dateRange")
    writer.println(" {")
    writer.indent {
      _DateRangeQuery(it).block()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _PanelSourceQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val entityType: Unit
    get() {
      writer.println("entityType")
    }

  public val mode: Unit
    get() {
      writer.println("mode")
    }

  public val manual: Unit
    get() {
      writer.println("manual")
    }

  public val sort: Unit
    get() {
      writer.println("sort")
    }

  public val limit: Unit
    get() {
      writer.println("limit")
    }

  public val minimum: Unit
    get() {
      writer.println("minimum")
    }

  public val deduplicate: Unit
    get() {
      writer.println("deduplicate")
    }

  public fun eventQuery(block: _EventQueryQuery.() -> Unit) {
    writer.print("eventQuery")
    writer.println(" {")
    writer.indent {
      _EventQueryQuery(it).block()
    }
    writer.println("}")
  }

  public fun eventQueries(block: _EventQueryQuery.() -> Unit) {
    writer.print("eventQueries")
    writer.println(" {")
    writer.indent {
      _EventQueryQuery(it).block()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _ContentPanelQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val id: Unit
    get() {
      writer.println("id")
    }

  public val type: Unit
    get() {
      writer.println("type")
    }

  public val title: Unit
    get() {
      writer.println("title")
    }

  public val titleLink: Unit
    get() {
      writer.println("titleLink")
    }

  public val subTitle: Unit
    get() {
      writer.println("subTitle")
    }

  public val subTitleLink: Unit
    get() {
      writer.println("subTitleLink")
    }

  public val content: Unit
    get() {
      writer.println("content")
    }

  public val entitiesSource: Unit
    get() {
      writer.println("entitiesSource")
    }

  public val articleSource: Unit
    get() {
      writer.println("articleSource")
    }

  public val displayOrder: Unit
    get() {
      writer.println("displayOrder")
    }

  public val flags: Unit
    get() {
      writer.println("flags")
    }

  public val minWidth: Unit
    get() {
      writer.println("minWidth")
    }

  public val maxWidth: Unit
    get() {
      writer.println("maxWidth")
    }

  public fun images(block: _ImageQuery.() -> Unit) {
    writer.print("images")
    writer.println(" {")
    writer.indent {
      _ImageQuery(it).block()
    }
    writer.println("}")
  }

  public fun entities(block: _EntityQuery.() -> Unit) {
    writer.print("entities")
    writer.println(" {")
    writer.indent {
      _EntityQuery(it).block()
    }
    writer.println("}")
  }

  public fun entityFilters(block: _EntityQuery.() -> Unit) {
    writer.print("entityFilters")
    writer.println(" {")
    writer.indent {
      _EntityQuery(it).block()
    }
    writer.println("}")
  }

  public fun filterTags(block: _TagQuery.() -> Unit) {
    writer.print("filterTags")
    writer.println(" {")
    writer.indent {
      _TagQuery(it).block()
    }
    writer.println("}")
  }

  public fun source(block: _PanelSourceQuery.() -> Unit) {
    writer.print("source")
    writer.println(" {")
    writer.indent {
      _PanelSourceQuery(it).block()
    }
    writer.println("}")
  }

  public fun links(block: _ContentViewLinkQuery.() -> Unit) {
    writer.print("links")
    writer.println(" {")
    writer.indent {
      _ContentViewLinkQuery(it).block()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _ContentViewQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val title: Unit
    get() {
      writer.println("title")
    }

  public val summary: Unit
    get() {
      writer.println("summary")
    }

  public val content: Unit
    get() {
      writer.println("content")
    }

  public fun images(block: _ImageQuery.() -> Unit) {
    writer.print("images")
    writer.println(" {")
    writer.indent {
      _ImageQuery(it).block()
    }
    writer.println("}")
  }

  public fun sections(block: _ContentViewSectionQuery.() -> Unit) {
    writer.print("sections")
    writer.println(" {")
    writer.indent {
      _ContentViewSectionQuery(it).block()
    }
    writer.println("}")
  }

  public fun links(block: _ContentViewLinkQuery.() -> Unit) {
    writer.print("links")
    writer.println(" {")
    writer.indent {
      _ContentViewLinkQuery(it).block()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _ContentViewLinkQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val path: Unit
    get() {
      writer.println("path")
    }

  public val name: Unit
    get() {
      writer.println("name")
    }

  public val description: Unit
    get() {
      writer.println("description")
    }

  public val type: Unit
    get() {
      writer.println("type")
    }
}

@GraphKtQuery
public class _ContentViewSectionQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val type: Unit
    get() {
      writer.println("type")
    }

  public val title: Unit
    get() {
      writer.println("title")
    }

  public val link: Unit
    get() {
      writer.println("link")
    }

  public val source: Unit
    get() {
      writer.println("source")
    }

  public val contentHtml: Unit
    get() {
      writer.println("contentHtml")
    }

  public fun content(block: _ContentViewEntityQuery.() -> Unit) {
    writer.print("content")
    writer.println(" {")
    writer.indent {
      _ContentViewEntityQuery(it).block()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _ContentViewEntityQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val id: Unit
    get() {
      writer.println("id")
    }

  public val name: Unit
    get() {
      writer.println("name")
    }

  public val description: Unit
    get() {
      writer.println("description")
    }

  public val path: Unit
    get() {
      writer.println("path")
    }

  public val containerName: Unit
    get() {
      writer.println("containerName")
    }

  public val containerPath: Unit
    get() {
      writer.println("containerPath")
    }

  public val action: Unit
    get() {
      writer.println("action")
    }

  public fun images(block: _ImageQuery.() -> Unit) {
    writer.print("images")
    writer.println(" {")
    writer.indent {
      _ImageQuery(it).block()
    }
    writer.println("}")
  }

  public fun tags(block: _TagQuery.() -> Unit) {
    writer.print("tags")
    writer.println(" {")
    writer.indent {
      _TagQuery(it).block()
    }
    writer.println("}")
  }

  public fun events(input: EventSearch, block: _EventSearchResultsQuery.() -> Unit) {
    writer.print("events")
    writer.print("(")
    writer.print("input: \$${writer.variable("input", "EventSearch!", EventSearch.serializer(), input)}")
    writer.print(")")
    writer.println(" {")
    writer.indent {
      _EventSearchResultsQuery(it).block()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _AccountsQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public fun me(block: _AccountQuery.() -> Unit) {
    writer.print("me")
    writer.println(" {")
    writer.indent {
      _AccountQuery(it).block()
    }
    writer.println("}")
  }

  public fun createAnonymous(input: CreateAnonymousInput, block: _CreateAccountResponseQuery.() -> Unit) {
    writer.print("createAnonymous")
    writer.print("(")
    writer.print("input: \$${writer.variable("input", "CreateAnonymousInput!", CreateAnonymousInput.serializer(), input)}")
    writer.print(")")
    writer.println(" {")
    writer.indent {
      _CreateAccountResponseQuery(it).block()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _CreateAccountResponseQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val id: Unit
    get() {
      writer.println("id")
    }

  public val token: Unit
    get() {
      writer.println("token")
    }
}

@GraphKtQuery
public class _AccountQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val createDate: Unit
    get() {
      writer.println("createDate")
    }

  public fun registerDevice(input: DeviceTokenRegistration) {
    writer.print("registerDevice")
    writer.print("(")
    writer.print("input: \$${writer.variable("input", "DeviceTokenRegistration!", DeviceTokenRegistration.serializer(), input)}")
    writer.print(")")
  }

  public fun unregisterDevice(input: DeviceTokenRegistration) {
    writer.print("unregisterDevice")
    writer.print("(")
    writer.print("input: \$${writer.variable("input", "DeviceTokenRegistration!", DeviceTokenRegistration.serializer(), input)}")
    writer.print(")")
  }
}

@GraphKtQuery
public class _ClientSupportQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public fun onboarding(block: _OnboardingQuery.() -> Unit) {
    writer.print("onboarding")
    writer.println(" {")
    writer.indent {
      _OnboardingQuery(it).block()
    }
    writer.println("}")
  }

  public fun logClientEvent(`data`: String) {
    writer.print("logClientEvent")
    writer.print("(")
    writer.print("data: \$${writer.variable("data", "String!", data)}")
    writer.print(")")
  }
}

@GraphKtQuery
public class _OnboardingQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public fun prefSelection(block: _OnboardingPrefQuery.() -> Unit) {
    writer.print("prefSelection")
    writer.println(" {")
    writer.indent {
      _OnboardingPrefQuery(it).block()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _OnboardingPrefQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val title: Unit
    get() {
      writer.println("title")
    }

  public val description: Unit
    get() {
      writer.println("description")
    }

  public fun entities(block: _EntityQuery.() -> Unit) {
    writer.print("entities")
    writer.println(" {")
    writer.indent {
      _EntityQuery(it).block()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _AuxContentQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public fun onboarding(block: _OnboardingQuery.() -> Unit) {
    writer.print("onboarding")
    writer.println(" {")
    writer.indent {
      _OnboardingQuery(it).block()
    }
    writer.println("}")
  }

  public fun features(block: _AuxFeaturesQuery.() -> Unit) {
    writer.print("features")
    writer.println(" {")
    writer.indent {
      _AuxFeaturesQuery(it).block()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _AuxFeaturesQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public fun feature(
    id: ID,
    input: ViewQuery?,
    block: _ViewConfigurationQuery.() -> Unit,
  ) {
    writer.print("feature")
    writer.print("(")
    var count = 0
    if (count++ > 0) writer.print(", ")
    writer.print("id: \$${writer.variable("id", "ID!", id)}")
    if (count++ > 0) writer.print(", ")
    if (input != null) {
      writer.print("input: \$${writer.variable("input", "ViewQuery", ViewQuery.serializer(), input)}")
    } else {
      writer.print("input: \$${writer.variable("input", "ViewQuery", null)}")
    }
    writer.print(")")
    writer.println(" {")
    writer.indent {
      _ViewConfigurationQuery(it).block()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _AdminMutationQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val domain: Unit
    get() {
      writer.println("domain")
    }

  public fun venues(block: _AdminVenuesQuery.() -> Unit) {
    writer.print("venues")
    writer.println(" {")
    writer.indent {
      _AdminVenuesQuery(it).block()
    }
    writer.println("}")
  }

  public fun events(block: _AdminEventsQuery.() -> Unit) {
    writer.print("events")
    writer.println(" {")
    writer.indent {
      _AdminEventsQuery(it).block()
    }
    writer.println("}")
  }

  public fun performers(block: _AdminPerformersQuery.() -> Unit) {
    writer.print("performers")
    writer.println(" {")
    writer.indent {
      _AdminPerformersQuery(it).block()
    }
    writer.println("}")
  }

  public fun articles(block: _AdminArticlesQuery.() -> Unit) {
    writer.print("articles")
    writer.println(" {")
    writer.indent {
      _AdminArticlesQuery(it).block()
    }
    writer.println("}")
  }

  public fun tags(block: _AdminTagsQuery.() -> Unit) {
    writer.print("tags")
    writer.println(" {")
    writer.indent {
      _AdminTagsQuery(it).block()
    }
    writer.println("}")
  }

  public fun images(block: _AdminImagesQuery.() -> Unit) {
    writer.print("images")
    writer.println(" {")
    writer.indent {
      _AdminImagesQuery(it).block()
    }
    writer.println("}")
  }

  public fun loaders(block: _AdminLoadersQuery.() -> Unit) {
    writer.print("loaders")
    writer.println(" {")
    writer.indent {
      _AdminLoadersQuery(it).block()
    }
    writer.println("}")
  }

  public fun logs(block: _AdminLogsQuery.() -> Unit) {
    writer.print("logs")
    writer.println(" {")
    writer.indent {
      _AdminLogsQuery(it).block()
    }
    writer.println("}")
  }

  public fun auxContent(block: _AdminContentViewsQuery.() -> Unit) {
    writer.print("auxContent")
    writer.println(" {")
    writer.indent {
      _AdminContentViewsQuery(it).block()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _AdminLogsQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public fun startQuery(input: LogQueryInput) {
    writer.print("startQuery")
    writer.print("(")
    writer.print("input: \$${writer.variable("input", "LogQueryInput!", LogQueryInput.serializer(), input)}")
    writer.print(")")
  }

  public fun results(queryId: ID, block: _LogQueryResultQuery.() -> Unit) {
    writer.print("results")
    writer.print("(")
    writer.print("queryId: \$${writer.variable("queryId", "ID!", queryId)}")
    writer.print(")")
    writer.println(" {")
    writer.indent {
      _LogQueryResultQuery(it).block()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _LogQueryResultQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val status: Unit
    get() {
      writer.println("status")
    }

  public fun rows(block: _LogQueryRowQuery.() -> Unit) {
    writer.print("rows")
    writer.println(" {")
    writer.indent {
      _LogQueryRowQuery(it).block()
    }
    writer.println("}")
  }

  public fun statistics(block: _LogQueryStatisticsQuery.() -> Unit) {
    writer.print("statistics")
    writer.println(" {")
    writer.indent {
      _LogQueryStatisticsQuery(it).block()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _LogQueryRowQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public fun fields(block: _LogQueryFieldQuery.() -> Unit) {
    writer.print("fields")
    writer.println(" {")
    writer.indent {
      _LogQueryFieldQuery(it).block()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _LogQueryFieldQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val `field`: Unit
    get() {
      writer.println("field")
    }

  public val `value`: Unit
    get() {
      writer.println("value")
    }
}

@GraphKtQuery
public class _LogQueryStatisticsQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val recordsMatched: Unit
    get() {
      writer.println("recordsMatched")
    }

  public val recordsScanned: Unit
    get() {
      writer.println("recordsScanned")
    }
}

@GraphKtQuery
public class _AdminImagesQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public fun upload(input: ImageUpload, block: _ImageQuery.() -> Unit) {
    writer.print("upload")
    writer.print("(")
    writer.print("input: \$${writer.variable("input", "ImageUpload!", ImageUpload.serializer(), input)}")
    writer.print(")")
    writer.println(" {")
    writer.indent {
      _ImageQuery(it).block()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _AdminVenuesQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public fun venue(id: ID, block: _AdminVenueQuery.() -> Unit) {
    writer.print("venue")
    writer.print("(")
    writer.print("id: \$${writer.variable("id", "ID!", id)}")
    writer.print(")")
    writer.println(" {")
    writer.indent {
      _AdminVenueQuery(it).block()
    }
    writer.println("}")
  }

  public fun add(
    id: ID,
    input: VenueUpdateInput,
    block: _AdminVenueQuery.() -> Unit,
  ) {
    writer.print("add")
    writer.print("(")
    var count = 0
    if (count++ > 0) writer.print(", ")
    writer.print("id: \$${writer.variable("id", "ID!", id)}")
    if (count++ > 0) writer.print(", ")
    writer.print("input: \$${writer.variable("input", "VenueUpdateInput!", VenueUpdateInput.serializer(), input)}")
    writer.print(")")
    writer.println(" {")
    writer.indent {
      _AdminVenueQuery(it).block()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _AdminVenueQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val id: Unit
    get() {
      writer.println("id")
    }

  public fun parent(block: _VenueQuery.() -> Unit) {
    writer.print("parent")
    writer.println(" {")
    writer.indent {
      _VenueQuery(it).block()
    }
    writer.println("}")
  }

  public fun children(block: _VenueQuery.() -> Unit) {
    writer.print("children")
    writer.println(" {")
    writer.indent {
      _VenueQuery(it).block()
    }
    writer.println("}")
  }

  public fun layers(block: _AdminVenueLayerQuery.() -> Unit) {
    writer.print("layers")
    writer.println(" {")
    writer.indent {
      _AdminVenueLayerQuery(it).block()
    }
    writer.println("}")
  }

  public fun layer(id: ID, block: _AdminVenueLayerQuery.() -> Unit) {
    writer.print("layer")
    writer.print("(")
    writer.print("id: \$${writer.variable("id", "ID!", id)}")
    writer.print(")")
    writer.println(" {")
    writer.indent {
      _AdminVenueLayerQuery(it).block()
    }
    writer.println("}")
  }

  public fun local(block: _AdminVenueLayerQuery.() -> Unit) {
    writer.print("local")
    writer.println(" {")
    writer.indent {
      _AdminVenueLayerQuery(it).block()
    }
    writer.println("}")
  }

  public fun resolved(block: _VenueQuery.() -> Unit) {
    writer.print("resolved")
    writer.println(" {")
    writer.indent {
      _VenueQuery(it).block()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _AdminVenueLayerQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val name: Unit
    get() {
      writer.println("name")
    }

  public val description: Unit
    get() {
      writer.println("description")
    }

  public val aliases: Unit
    get() {
      writer.println("aliases")
    }

  public val ticketsUrl: Unit
    get() {
      writer.println("ticketsUrl")
    }

  public val status: Unit
    get() {
      writer.println("status")
    }

  public val rankingScore: Unit
    get() {
      writer.println("rankingScore")
    }

  public val eventStreamId: Unit
    get() {
      writer.println("eventStreamId")
    }

  public val parking: Unit
    get() {
      writer.println("parking")
    }

  public val contentView: Unit
    get() {
      writer.println("contentView")
    }

  public fun address(block: _AddressQuery.() -> Unit) {
    writer.print("address")
    writer.println(" {")
    writer.indent {
      _AddressQuery(it).block()
    }
    writer.println("}")
  }

  public fun location(block: _GPSCoordinatesQuery.() -> Unit) {
    writer.print("location")
    writer.println(" {")
    writer.indent {
      _GPSCoordinatesQuery(it).block()
    }
    writer.println("}")
  }

  public fun links(block: _SocialLinkQuery.() -> Unit) {
    writer.print("links")
    writer.println(" {")
    writer.indent {
      _SocialLinkQuery(it).block()
    }
    writer.println("}")
  }

  public fun tags(block: _TagQuery.() -> Unit) {
    writer.print("tags")
    writer.println(" {")
    writer.indent {
      _TagQuery(it).block()
    }
    writer.println("}")
  }

  public fun images(block: _ImageQuery.() -> Unit) {
    writer.print("images")
    writer.println(" {")
    writer.indent {
      _ImageQuery(it).block()
    }
    writer.println("}")
  }

  public fun redirect(block: _VenueQuery.() -> Unit) {
    writer.print("redirect")
    writer.println(" {")
    writer.indent {
      _VenueQuery(it).block()
    }
    writer.println("}")
  }

  public fun update(input: VenueUpdateInput, block: _AdminVenueLayerQuery.() -> Unit) {
    writer.print("update")
    writer.print("(")
    writer.print("input: \$${writer.variable("input", "VenueUpdateInput!", VenueUpdateInput.serializer(), input)}")
    writer.print(")")
    writer.println(" {")
    writer.indent {
      _AdminVenueLayerQuery(it).block()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _AdminPerformersQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public fun performer(id: ID, block: _AdminPerformerQuery.() -> Unit) {
    writer.print("performer")
    writer.print("(")
    writer.print("id: \$${writer.variable("id", "ID!", id)}")
    writer.print(")")
    writer.println(" {")
    writer.indent {
      _AdminPerformerQuery(it).block()
    }
    writer.println("}")
  }

  public fun add(
    id: ID,
    input: PerformerUpdateInput,
    block: _AdminPerformerQuery.() -> Unit,
  ) {
    writer.print("add")
    writer.print("(")
    var count = 0
    if (count++ > 0) writer.print(", ")
    writer.print("id: \$${writer.variable("id", "ID!", id)}")
    if (count++ > 0) writer.print(", ")
    writer.print("input: \$${writer.variable("input", "PerformerUpdateInput!", PerformerUpdateInput.serializer(), input)}")
    writer.print(")")
    writer.println(" {")
    writer.indent {
      _AdminPerformerQuery(it).block()
    }
    writer.println("}")
  }

  public fun enhance(
    id: ID,
    apply: Boolean,
    block: _PerformerUpdateQuery.() -> Unit,
  ) {
    writer.print("enhance")
    writer.print("(")
    var count = 0
    if (count++ > 0) writer.print(", ")
    writer.print("id: \$${writer.variable("id", "ID!", id)}")
    if (count++ > 0) writer.print(", ")
    writer.print("apply: \$${writer.variable("apply", "Boolean!", apply)}")
    writer.print(")")
    writer.println(" {")
    writer.indent {
      _PerformerUpdateQuery(it).block()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _SourceDataSearchResultQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val id: Unit
    get() {
      writer.println("id")
    }

  public val description: Unit
    get() {
      writer.println("description")
    }
}

@GraphKtQuery
public class _AdminPerformerQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val id: Unit
    get() {
      writer.println("id")
    }

  public fun layers(block: _AdminPerformerLayerQuery.() -> Unit) {
    writer.print("layers")
    writer.println(" {")
    writer.indent {
      _AdminPerformerLayerQuery(it).block()
    }
    writer.println("}")
  }

  public fun layer(id: ID, block: _AdminPerformerLayerQuery.() -> Unit) {
    writer.print("layer")
    writer.print("(")
    writer.print("id: \$${writer.variable("id", "ID!", id)}")
    writer.print(")")
    writer.println(" {")
    writer.indent {
      _AdminPerformerLayerQuery(it).block()
    }
    writer.println("}")
  }

  public fun local(block: _AdminPerformerLayerQuery.() -> Unit) {
    writer.print("local")
    writer.println(" {")
    writer.indent {
      _AdminPerformerLayerQuery(it).block()
    }
    writer.println("}")
  }

  public fun resolved(block: _PerformerQuery.() -> Unit) {
    writer.print("resolved")
    writer.println(" {")
    writer.indent {
      _PerformerQuery(it).block()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _AdminPerformerLayerQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val name: Unit
    get() {
      writer.println("name")
    }

  public val description: Unit
    get() {
      writer.println("description")
    }

  public val aliases: Unit
    get() {
      writer.println("aliases")
    }

  public val wikiIdentifier: Unit
    get() {
      writer.println("wikiIdentifier")
    }

  public val rankingScore: Unit
    get() {
      writer.println("rankingScore")
    }

  public fun images(block: _ImageQuery.() -> Unit) {
    writer.print("images")
    writer.println(" {")
    writer.indent {
      _ImageQuery(it).block()
    }
    writer.println("}")
  }

  public fun tags(block: _TagQuery.() -> Unit) {
    writer.print("tags")
    writer.println(" {")
    writer.indent {
      _TagQuery(it).block()
    }
    writer.println("}")
  }

  public fun update(input: PerformerUpdateInput, block: _AdminPerformerLayerQuery.() -> Unit) {
    writer.print("update")
    writer.print("(")
    writer.print("input: \$${writer.variable("input", "PerformerUpdateInput!", PerformerUpdateInput.serializer(), input)}")
    writer.print(")")
    writer.println(" {")
    writer.indent {
      _AdminPerformerLayerQuery(it).block()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _PerformerUpdateQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val name: Unit
    get() {
      writer.println("name")
    }

  public val description: Unit
    get() {
      writer.println("description")
    }

  public val aliases: Unit
    get() {
      writer.println("aliases")
    }

  public val tags: Unit
    get() {
      writer.println("tags")
    }

  public val images: Unit
    get() {
      writer.println("images")
    }

  public val wikiIdentifier: Unit
    get() {
      writer.println("wikiIdentifier")
    }

  public val rankingScore: Unit
    get() {
      writer.println("rankingScore")
    }
}

@GraphKtQuery
public class _AdminEventsQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public fun event(id: ID, block: _AdminEventQuery.() -> Unit) {
    writer.print("event")
    writer.print("(")
    writer.print("id: \$${writer.variable("id", "ID!", id)}")
    writer.print(")")
    writer.println(" {")
    writer.indent {
      _AdminEventQuery(it).block()
    }
    writer.println("}")
  }

  public fun reviewNext(block: _AdminEventQuery.() -> Unit) {
    writer.print("reviewNext")
    writer.println(" {")
    writer.indent {
      _AdminEventQuery(it).block()
    }
    writer.println("}")
  }

  public fun add(input: EventUpdateInput, block: _AdminEventQuery.() -> Unit) {
    writer.print("add")
    writer.print("(")
    writer.print("input: \$${writer.variable("input", "EventUpdateInput!", EventUpdateInput.serializer(), input)}")
    writer.print(")")
    writer.println(" {")
    writer.indent {
      _AdminEventQuery(it).block()
    }
    writer.println("}")
  }

  public fun forReview(block: _EventQuery.() -> Unit) {
    writer.print("forReview")
    writer.println(" {")
    writer.indent {
      _EventQuery(it).block()
    }
    writer.println("}")
  }

  public fun merge(input: MergeInput, block: _AdminEventQuery.() -> Unit) {
    writer.print("merge")
    writer.print("(")
    writer.print("input: \$${writer.variable("input", "MergeInput!", MergeInput.serializer(), input)}")
    writer.print(")")
    writer.println(" {")
    writer.indent {
      _AdminEventQuery(it).block()
    }
    writer.println("}")
  }

  public fun enhance(
    id: ID,
    apply: Boolean,
    block: _EventUpdateQuery.() -> Unit,
  ) {
    writer.print("enhance")
    writer.print("(")
    var count = 0
    if (count++ > 0) writer.print(", ")
    writer.print("id: \$${writer.variable("id", "ID!", id)}")
    if (count++ > 0) writer.print(", ")
    writer.print("apply: \$${writer.variable("apply", "Boolean!", apply)}")
    writer.print(")")
    writer.println(" {")
    writer.indent {
      _EventUpdateQuery(it).block()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _AdminEventQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val id: Unit
    get() {
      writer.println("id")
    }

  public val deactivatedTs: Unit
    get() {
      writer.println("deactivatedTs")
    }

  public val activatedTs: Unit
    get() {
      writer.println("activatedTs")
    }

  public fun layers(block: _AdminEventLayerQuery.() -> Unit) {
    writer.print("layers")
    writer.println(" {")
    writer.indent {
      _AdminEventLayerQuery(it).block()
    }
    writer.println("}")
  }

  public fun layer(id: ID, block: _AdminEventLayerQuery.() -> Unit) {
    writer.print("layer")
    writer.print("(")
    writer.print("id: \$${writer.variable("id", "ID!", id)}")
    writer.print(")")
    writer.println(" {")
    writer.indent {
      _AdminEventLayerQuery(it).block()
    }
    writer.println("}")
  }

  public fun local(block: _AdminEventLayerQuery.() -> Unit) {
    writer.print("local")
    writer.println(" {")
    writer.indent {
      _AdminEventLayerQuery(it).block()
    }
    writer.println("}")
  }

  public fun resolved(block: _EventQuery.() -> Unit) {
    writer.print("resolved")
    writer.println(" {")
    writer.indent {
      _EventQuery(it).block()
    }
    writer.println("}")
  }

  public fun parent(block: _EventQuery.() -> Unit) {
    writer.print("parent")
    writer.println(" {")
    writer.indent {
      _EventQuery(it).block()
    }
    writer.println("}")
  }

  public fun children(block: _EventQuery.() -> Unit) {
    writer.print("children")
    writer.println(" {")
    writer.indent {
      _EventQuery(it).block()
    }
    writer.println("}")
  }

  public fun review(input: EventUpdateInput) {
    writer.print("review")
    writer.print("(")
    writer.print("input: \$${writer.variable("input", "EventUpdateInput!", EventUpdateInput.serializer(), input)}")
    writer.print(")")
  }

  public fun rebuild(message: String?) {
    writer.print("rebuild")
    writer.print("(")
    if (message != null) {
      writer.print("message: \$${writer.variable("message", "String", message)}")
    } else {
      writer.print("message: \$${writer.variable("message", "String", null)}")
    }
    writer.print(")")
  }

  public fun disable(delete: Boolean) {
    writer.print("disable")
    writer.print("(")
    writer.print("delete: \$${writer.variable("delete", "Boolean!", delete)}")
    writer.print(")")
  }

  public fun generateSocialImage(
    renderer: SocialImageRenderer,
    dateStyle: SocialImageDateStyle,
    omitTime: Boolean,
    includeTagline: Boolean,
    includeVenue: Boolean,
    forceCover: Boolean,
  ) {
    writer.print("generateSocialImage")
    writer.print("(")
    var count = 0
    if (count++ > 0) writer.print(", ")
    writer.print("renderer: \$${writer.variable("renderer", "SocialImageRenderer!", renderer.name)}")
    if (count++ > 0) writer.print(", ")
    writer.print("dateStyle: \$${writer.variable("dateStyle", "SocialImageDateStyle!", dateStyle.name)}")
    if (count++ > 0) writer.print(", ")
    writer.print("omitTime: \$${writer.variable("omitTime", "Boolean!", omitTime)}")
    if (count++ > 0) writer.print(", ")
    writer.print("includeTagline: \$${writer.variable("includeTagline", "Boolean!", includeTagline)}")
    if (count++ > 0) writer.print(", ")
    writer.print("includeVenue: \$${writer.variable("includeVenue", "Boolean!", includeVenue)}")
    if (count++ > 0) writer.print(", ")
    writer.print("forceCover: \$${writer.variable("forceCover", "Boolean!", forceCover)}")
    writer.print(")")
  }

  public fun socialImageStatus(url: String, block: _SocialImageStatusQuery.() -> Unit) {
    writer.print("socialImageStatus")
    writer.print("(")
    writer.print("url: \$${writer.variable("url", "String!", url)}")
    writer.print(")")
    writer.println(" {")
    writer.indent {
      _SocialImageStatusQuery(it).block()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _SocialImageStatusQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val state: Unit
    get() {
      writer.println("state")
    }

  public val url: Unit
    get() {
      writer.println("url")
    }

  public val error: Unit
    get() {
      writer.println("error")
    }
}

@GraphKtQuery
public class _AdminEventLayerQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val layerId: Unit
    get() {
      writer.println("layerId")
    }

  public val name: Unit
    get() {
      writer.println("name")
    }

  public val description: Unit
    get() {
      writer.println("description")
    }

  public val date: Unit
    get() {
      writer.println("date")
    }

  public val time: Unit
    get() {
      writer.println("time")
    }

  public val duration: Unit
    get() {
      writer.println("duration")
    }

  public val expiration: Unit
    get() {
      writer.println("expiration")
    }

  public val ticketsUrl: Unit
    get() {
      writer.println("ticketsUrl")
    }

  public val sourceUrl: Unit
    get() {
      writer.println("sourceUrl")
    }

  public val aliases: Unit
    get() {
      writer.println("aliases")
    }

  public val lastUpdated: Unit
    get() {
      writer.println("lastUpdated")
    }

  public val excluded: Unit
    get() {
      writer.println("excluded")
    }

  public val rankingScore: Unit
    get() {
      writer.println("rankingScore")
    }

  public val tagline: Unit
    get() {
      writer.println("tagline")
    }

  public val suggestedPerformers: Unit
    get() {
      writer.println("suggestedPerformers")
    }

  public val contentView: Unit
    get() {
      writer.println("contentView")
    }

  public fun images(block: _ImageQuery.() -> Unit) {
    writer.print("images")
    writer.println(" {")
    writer.indent {
      _ImageQuery(it).block()
    }
    writer.println("}")
  }

  public fun excludedImages(block: _ImageQuery.() -> Unit) {
    writer.print("excludedImages")
    writer.println(" {")
    writer.indent {
      _ImageQuery(it).block()
    }
    writer.println("}")
  }

  public fun tags(block: _TagQuery.() -> Unit) {
    writer.print("tags")
    writer.println(" {")
    writer.indent {
      _TagQuery(it).block()
    }
    writer.println("}")
  }

  public fun excludedTags(block: _TagQuery.() -> Unit) {
    writer.print("excludedTags")
    writer.println(" {")
    writer.indent {
      _TagQuery(it).block()
    }
    writer.println("}")
  }

  public fun performers(block: _PerformerQuery.() -> Unit) {
    writer.print("performers")
    writer.println(" {")
    writer.indent {
      _PerformerQuery(it).block()
    }
    writer.println("}")
  }

  public fun venue(block: _VenueQuery.() -> Unit) {
    writer.print("venue")
    writer.println(" {")
    writer.indent {
      _VenueQuery(it).block()
    }
    writer.println("}")
  }

  public fun update(input: EventUpdateInput, block: _AdminEventLayerQuery.() -> Unit) {
    writer.print("update")
    writer.print("(")
    writer.print("input: \$${writer.variable("input", "EventUpdateInput!", EventUpdateInput.serializer(), input)}")
    writer.print(")")
    writer.println(" {")
    writer.indent {
      _AdminEventLayerQuery(it).block()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _EventTagQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val id: Unit
    get() {
      writer.println("id")
    }

  public val name: Unit
    get() {
      writer.println("name")
    }

  public val confidence: Unit
    get() {
      writer.println("confidence")
    }
}

@GraphKtQuery
public class _EventUpdateQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val parent: Unit
    get() {
      writer.println("parent")
    }

  public val name: Unit
    get() {
      writer.println("name")
    }

  public val description: Unit
    get() {
      writer.println("description")
    }

  public val venue: Unit
    get() {
      writer.println("venue")
    }

  public val date: Unit
    get() {
      writer.println("date")
    }

  public val time: Unit
    get() {
      writer.println("time")
    }

  public val duration: Unit
    get() {
      writer.println("duration")
    }

  public val endDate: Unit
    get() {
      writer.println("endDate")
    }

  public val endTime: Unit
    get() {
      writer.println("endTime")
    }

  public val ticketsUrl: Unit
    get() {
      writer.println("ticketsUrl")
    }

  public val sourceUrl: Unit
    get() {
      writer.println("sourceUrl")
    }

  public val aliases: Unit
    get() {
      writer.println("aliases")
    }

  public val images: Unit
    get() {
      writer.println("images")
    }

  public val excludedImages: Unit
    get() {
      writer.println("excludedImages")
    }

  public val excludedTags: Unit
    get() {
      writer.println("excludedTags")
    }

  public val performers: Unit
    get() {
      writer.println("performers")
    }

  public val excluded: Unit
    get() {
      writer.println("excluded")
    }

  public val rankingScore: Unit
    get() {
      writer.println("rankingScore")
    }

  public val suggestedPerformers: Unit
    get() {
      writer.println("suggestedPerformers")
    }

  public fun eventTags(block: _EventTagQuery.() -> Unit) {
    writer.print("eventTags")
    writer.println(" {")
    writer.indent {
      _EventTagQuery(it).block()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _AdminArticlesQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public fun article(id: ID, block: _AdminArticleQuery.() -> Unit) {
    writer.print("article")
    writer.print("(")
    writer.print("id: \$${writer.variable("id", "ID!", id)}")
    writer.print(")")
    writer.println(" {")
    writer.indent {
      _AdminArticleQuery(it).block()
    }
    writer.println("}")
  }

  public fun new(
    id: ID?,
    input: ArticleInput,
    block: _AdminArticleQuery.() -> Unit,
  ) {
    writer.print("new")
    writer.print("(")
    var count = 0
    if (count++ > 0) writer.print(", ")
    if (id != null) {
      writer.print("id: \$${writer.variable("id", "ID", id)}")
    } else {
      writer.print("id: \$${writer.variable("id", "ID", null)}")
    }
    if (count++ > 0) writer.print(", ")
    writer.print("input: \$${writer.variable("input", "ArticleInput!", ArticleInput.serializer(), input)}")
    writer.print(")")
    writer.println(" {")
    writer.indent {
      _AdminArticleQuery(it).block()
    }
    writer.println("}")
  }

  public fun drafts(block: _AdminArticleQuery.() -> Unit) {
    writer.print("drafts")
    writer.println(" {")
    writer.indent {
      _AdminArticleQuery(it).block()
    }
    writer.println("}")
  }

  public fun content(id: ID, block: _AdminArticleQuery.() -> Unit) {
    writer.print("content")
    writer.print("(")
    writer.print("id: \$${writer.variable("id", "ID!", id)}")
    writer.print(")")
    writer.println(" {")
    writer.indent {
      _AdminArticleQuery(it).block()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _AdminArticleQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val id: Unit
    get() {
      writer.println("id")
    }

  public val title: Unit
    get() {
      writer.println("title")
    }

  public val summary: Unit
    get() {
      writer.println("summary")
    }

  public val content: Unit
    get() {
      writer.println("content")
    }

  public val created: Unit
    get() {
      writer.println("created")
    }

  public val updated: Unit
    get() {
      writer.println("updated")
    }

  public val published: Unit
    get() {
      writer.println("published")
    }

  public val startTs: Unit
    get() {
      writer.println("startTs")
    }

  public val endTs: Unit
    get() {
      writer.println("endTs")
    }

  public fun links(block: _EntityQuery.() -> Unit) {
    writer.print("links")
    writer.println(" {")
    writer.indent {
      _EntityQuery(it).block()
    }
    writer.println("}")
  }

  public fun resolvedLinks(block: _EntityQuery.() -> Unit) {
    writer.print("resolvedLinks")
    writer.println(" {")
    writer.indent {
      _EntityQuery(it).block()
    }
    writer.println("}")
  }

  public fun images(block: _ImageQuery.() -> Unit) {
    writer.print("images")
    writer.println(" {")
    writer.indent {
      _ImageQuery(it).block()
    }
    writer.println("}")
  }

  public fun update(input: ArticleInput, block: _AdminArticleQuery.() -> Unit) {
    writer.print("update")
    writer.print("(")
    writer.print("input: \$${writer.variable("input", "ArticleInput!", ArticleInput.serializer(), input)}")
    writer.print(")")
    writer.println(" {")
    writer.indent {
      _AdminArticleQuery(it).block()
    }
    writer.println("}")
  }

  public fun publish(time: AWSDateTime?, block: _AdminArticleQuery.() -> Unit) {
    writer.print("publish")
    writer.print("(")
    if (time != null) {
      writer.print("time: \$${writer.variable("time", "AWSDateTime", AWSDateTime.serializer(), time)}")
    } else {
      writer.print("time: \$${writer.variable("time", "AWSDateTime", null)}")
    }
    writer.print(")")
    writer.println(" {")
    writer.indent {
      _AdminArticleQuery(it).block()
    }
    writer.println("}")
  }

  public fun unpublish(block: _AdminArticleQuery.() -> Unit) {
    writer.print("unpublish")
    writer.println(" {")
    writer.indent {
      _AdminArticleQuery(it).block()
    }
    writer.println("}")
  }

  public fun delete(confirmation: Boolean) {
    writer.print("delete")
    writer.print("(")
    writer.print("confirmation: \$${writer.variable("confirmation", "Boolean!", confirmation)}")
    writer.print(")")
  }
}

@GraphKtQuery
public class _AdminTagsQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public fun all(block: _AdminTagQuery.() -> Unit) {
    writer.print("all")
    writer.println(" {")
    writer.indent {
      _AdminTagQuery(it).block()
    }
    writer.println("}")
  }

  public fun tag(id: ID, block: _AdminTagQuery.() -> Unit) {
    writer.print("tag")
    writer.print("(")
    writer.print("id: \$${writer.variable("id", "ID!", id)}")
    writer.print(")")
    writer.println(" {")
    writer.indent {
      _AdminTagQuery(it).block()
    }
    writer.println("}")
  }

  public fun add(
    id: ID,
    input: TagUpdateInput,
    block: _AdminTagQuery.() -> Unit,
  ) {
    writer.print("add")
    writer.print("(")
    var count = 0
    if (count++ > 0) writer.print(", ")
    writer.print("id: \$${writer.variable("id", "ID!", id)}")
    if (count++ > 0) writer.print(", ")
    writer.print("input: \$${writer.variable("input", "TagUpdateInput!", TagUpdateInput.serializer(), input)}")
    writer.print(")")
    writer.println(" {")
    writer.indent {
      _AdminTagQuery(it).block()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _AdminTagQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val id: Unit
    get() {
      writer.println("id")
    }

  public fun layers(block: _AdminTagLayerQuery.() -> Unit) {
    writer.print("layers")
    writer.println(" {")
    writer.indent {
      _AdminTagLayerQuery(it).block()
    }
    writer.println("}")
  }

  public fun layer(id: ID, block: _AdminTagLayerQuery.() -> Unit) {
    writer.print("layer")
    writer.print("(")
    writer.print("id: \$${writer.variable("id", "ID!", id)}")
    writer.print(")")
    writer.println(" {")
    writer.indent {
      _AdminTagLayerQuery(it).block()
    }
    writer.println("}")
  }

  public fun local(block: _AdminTagLayerQuery.() -> Unit) {
    writer.print("local")
    writer.println(" {")
    writer.indent {
      _AdminTagLayerQuery(it).block()
    }
    writer.println("}")
  }

  public fun resolved(block: _TagQuery.() -> Unit) {
    writer.print("resolved")
    writer.println(" {")
    writer.indent {
      _TagQuery(it).block()
    }
    writer.println("}")
  }

  public fun children(block: _TagQuery.() -> Unit) {
    writer.print("children")
    writer.println(" {")
    writer.indent {
      _TagQuery(it).block()
    }
    writer.println("}")
  }

  public fun parent(block: _TagQuery.() -> Unit) {
    writer.print("parent")
    writer.println(" {")
    writer.indent {
      _TagQuery(it).block()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _AdminTagLayerQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val name: Unit
    get() {
      writer.println("name")
    }

  public val description: Unit
    get() {
      writer.println("description")
    }

  public val childLimit: Unit
    get() {
      writer.println("childLimit")
    }

  public val shadow: Unit
    get() {
      writer.println("shadow")
    }

  public val pageTitle: Unit
    get() {
      writer.println("pageTitle")
    }

  public val rankingScore: Unit
    get() {
      writer.println("rankingScore")
    }

  public val aiPromptInput: Unit
    get() {
      writer.println("aiPromptInput")
    }

  public val contentView: Unit
    get() {
      writer.println("contentView")
    }

  public fun images(block: _ImageQuery.() -> Unit) {
    writer.print("images")
    writer.println(" {")
    writer.indent {
      _ImageQuery(it).block()
    }
    writer.println("}")
  }

  public fun parent(block: _TagQuery.() -> Unit) {
    writer.print("parent")
    writer.println(" {")
    writer.indent {
      _TagQuery(it).block()
    }
    writer.println("}")
  }

  public fun impliedTags(block: _TagQuery.() -> Unit) {
    writer.print("impliedTags")
    writer.println(" {")
    writer.indent {
      _TagQuery(it).block()
    }
    writer.println("}")
  }

  public fun update(input: TagUpdateInput, block: _AdminTagLayerQuery.() -> Unit) {
    writer.print("update")
    writer.print("(")
    writer.print("input: \$${writer.variable("input", "TagUpdateInput!", TagUpdateInput.serializer(), input)}")
    writer.print(")")
    writer.println(" {")
    writer.indent {
      _AdminTagLayerQuery(it).block()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _AdminLoadersQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public fun modules(block: _AdminLoaderModuleQuery.() -> Unit) {
    writer.print("modules")
    writer.println(" {")
    writer.indent {
      _AdminLoaderModuleQuery(it).block()
    }
    writer.println("}")
  }

  public fun module(id: ID, block: _AdminLoaderModuleQuery.() -> Unit) {
    writer.print("module")
    writer.print("(")
    writer.print("id: \$${writer.variable("id", "ID!", id)}")
    writer.print(")")
    writer.println(" {")
    writer.indent {
      _AdminLoaderModuleQuery(it).block()
    }
    writer.println("}")
  }

  public fun loaders(block: _AdminLoaderQuery.() -> Unit) {
    writer.print("loaders")
    writer.println(" {")
    writer.indent {
      _AdminLoaderQuery(it).block()
    }
    writer.println("}")
  }

  public fun loader(id: ID, block: _AdminLoaderQuery.() -> Unit) {
    writer.print("loader")
    writer.print("(")
    writer.print("id: \$${writer.variable("id", "ID!", id)}")
    writer.print(")")
    writer.println(" {")
    writer.indent {
      _AdminLoaderQuery(it).block()
    }
    writer.println("}")
  }

  public fun registerLoader(
    id: ID,
    input: LoaderConfiguration,
    block: _AdminLoaderQuery.() -> Unit,
  ) {
    writer.print("registerLoader")
    writer.print("(")
    var count = 0
    if (count++ > 0) writer.print(", ")
    writer.print("id: \$${writer.variable("id", "ID!", id)}")
    if (count++ > 0) writer.print(", ")
    writer.print("input: \$${writer.variable("input", "LoaderConfiguration!", LoaderConfiguration.serializer(), input)}")
    writer.print(")")
    writer.println(" {")
    writer.indent {
      _AdminLoaderQuery(it).block()
    }
    writer.println("}")
  }

  public fun deregister(id: ID) {
    writer.print("deregister")
    writer.print("(")
    writer.print("id: \$${writer.variable("id", "ID!", id)}")
    writer.print(")")
  }
}

@GraphKtQuery
public class _AdminLoaderModuleQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val id: Unit
    get() {
      writer.println("id")
    }

  public val name: Unit
    get() {
      writer.println("name")
    }
}

@GraphKtQuery
public class _AdminLoaderQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val id: Unit
    get() {
      writer.println("id")
    }

  public val name: Unit
    get() {
      writer.println("name")
    }

  public val schedule: Unit
    get() {
      writer.println("schedule")
    }

  public val parameters: Unit
    get() {
      writer.println("parameters")
    }

  public val reprocess: Unit
    get() {
      writer.println("reprocess")
    }

  public fun module(block: _AdminLoaderModuleQuery.() -> Unit) {
    writer.print("module")
    writer.println(" {")
    writer.indent {
      _AdminLoaderModuleQuery(it).block()
    }
    writer.println("}")
  }

  public fun update(input: LoaderConfiguration, block: _AdminLoaderQuery.() -> Unit) {
    writer.print("update")
    writer.print("(")
    writer.print("input: \$${writer.variable("input", "LoaderConfiguration!", LoaderConfiguration.serializer(), input)}")
    writer.print(")")
    writer.println(" {")
    writer.indent {
      _AdminLoaderQuery(it).block()
    }
    writer.println("}")
  }

  public fun recentExecutions(block: _LoaderExecutionQuery.() -> Unit) {
    writer.print("recentExecutions")
    writer.println(" {")
    writer.indent {
      _LoaderExecutionQuery(it).block()
    }
    writer.println("}")
  }

  public fun logs(
    start: AWSDateTime,
    end: AWSDateTime,
    block: _LogEventQuery.() -> Unit,
  ) {
    writer.print("logs")
    writer.print("(")
    var count = 0
    if (count++ > 0) writer.print(", ")
    writer.print("start: \$${writer.variable("start", "AWSDateTime!", AWSDateTime.serializer(), start)}")
    if (count++ > 0) writer.print(", ")
    writer.print("end: \$${writer.variable("end", "AWSDateTime!", AWSDateTime.serializer(), end)}")
    writer.print(")")
    writer.println(" {")
    writer.indent {
      _LogEventQuery(it).block()
    }
    writer.println("}")
  }

  public fun execute(input: LoaderExecutionInput?) {
    writer.print("execute")
    writer.print("(")
    if (input != null) {
      writer.print("input: \$${writer.variable("input", "LoaderExecutionInput", LoaderExecutionInput.serializer(), input)}")
    } else {
      writer.print("input: \$${writer.variable("input", "LoaderExecutionInput", null)}")
    }
    writer.print(")")
  }

  public fun publish(input: LoaderPublishInput) {
    writer.print("publish")
    writer.print("(")
    writer.print("input: \$${writer.variable("input", "LoaderPublishInput!", LoaderPublishInput.serializer(), input)}")
    writer.print(")")
  }

  public fun readInternalData(key: String) {
    writer.print("readInternalData")
    writer.print("(")
    writer.print("key: \$${writer.variable("key", "String!", key)}")
    writer.print(")")
  }

  public fun saveInternalData(key: String, `data`: String) {
    writer.print("saveInternalData")
    writer.print("(")
    var count = 0
    if (count++ > 0) writer.print(", ")
    writer.print("key: \$${writer.variable("key", "String!", key)}")
    if (count++ > 0) writer.print(", ")
    writer.print("data: \$${writer.variable("data", "String!", data)}")
    writer.print(")")
  }

  public fun lastLoad(block: _LoaderExecutionQuery.() -> Unit) {
    writer.print("lastLoad")
    writer.println(" {")
    writer.indent {
      _LoaderExecutionQuery(it).block()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _LogEventQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val ts: Unit
    get() {
      writer.println("ts")
    }

  public val message: Unit
    get() {
      writer.println("message")
    }
}

@GraphKtQuery
public class _LoaderExecutionQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val ts: Unit
    get() {
      writer.println("ts")
    }

  public val events: Unit
    get() {
      writer.println("events")
    }
}

@GraphKtQuery
public class _AdminContentViewsQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public fun configuration(id: ID, block: _AdminContentViewQuery.() -> Unit) {
    writer.print("configuration")
    writer.print("(")
    writer.print("id: \$${writer.variable("id", "ID!", id)}")
    writer.print(")")
    writer.println(" {")
    writer.indent {
      _AdminContentViewQuery(it).block()
    }
    writer.println("}")
  }

  public fun create(id: ID, block: _AdminContentViewQuery.() -> Unit) {
    writer.print("create")
    writer.print("(")
    writer.print("id: \$${writer.variable("id", "ID!", id)}")
    writer.print(")")
    writer.println(" {")
    writer.indent {
      _AdminContentViewQuery(it).block()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _AdminContentViewQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val id: Unit
    get() {
      writer.println("id")
    }

  public fun panels(block: _ContentPanelQuery.() -> Unit) {
    writer.print("panels")
    writer.println(" {")
    writer.indent {
      _ContentPanelQuery(it).block()
    }
    writer.println("}")
  }

  public fun addPanel(
    input: ContentPanelInput,
    index: Int?,
    block: _ContentPanelQuery.() -> Unit,
  ) {
    writer.print("addPanel")
    writer.print("(")
    var count = 0
    if (count++ > 0) writer.print(", ")
    writer.print("input: \$${writer.variable("input", "ContentPanelInput!", ContentPanelInput.serializer(), input)}")
    if (count++ > 0) writer.print(", ")
    if (index != null) {
      writer.print("index: \$${writer.variable("index", "Int", index)}")
    } else {
      writer.print("index: \$${writer.variable("index", "Int", null)}")
    }
    writer.print(")")
    writer.println(" {")
    writer.indent {
      _ContentPanelQuery(it).block()
    }
    writer.println("}")
  }

  public fun editPanel(
    id: ID,
    input: ContentPanelInput,
    block: _ContentPanelQuery.() -> Unit,
  ) {
    writer.print("editPanel")
    writer.print("(")
    var count = 0
    if (count++ > 0) writer.print(", ")
    writer.print("id: \$${writer.variable("id", "ID!", id)}")
    if (count++ > 0) writer.print(", ")
    writer.print("input: \$${writer.variable("input", "ContentPanelInput!", ContentPanelInput.serializer(), input)}")
    writer.print(")")
    writer.println(" {")
    writer.indent {
      _ContentPanelQuery(it).block()
    }
    writer.println("}")
  }

  public fun deletePanel(id: ID) {
    writer.print("deletePanel")
    writer.print("(")
    writer.print("id: \$${writer.variable("id", "ID!", id)}")
    writer.print(")")
  }

  public fun movePanel(id: ID, index: Int) {
    writer.print("movePanel")
    writer.print("(")
    var count = 0
    if (count++ > 0) writer.print(", ")
    writer.print("id: \$${writer.variable("id", "ID!", id)}")
    if (count++ > 0) writer.print(", ")
    writer.print("index: \$${writer.variable("index", "Int!", index)}")
    writer.print(")")
  }
}

public suspend fun GraphQLClient.query(name: String? = null, block: _QueryQuery.() -> Unit): Query {
  val result = executeAndParse(name, json, ::QueryResponse) {
    this.type = "query"
    _QueryQuery(this).block()
  }
  return result
}

public suspend fun GraphQLClient.mutation(name: String? = null, block: _MutationQuery.() -> Unit): Mutation {
  val result = executeAndParse(name, json, ::MutationResponse) {
    this.type = "mutation"
    _MutationQuery(this).block()
  }
  return result
}
